module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/press.json
// module id = 1454
// module chunks = 256360735588706